import * as React from 'react';
import { classNames, UitkContextProvider } from 'uitk-react-utils';
import styles from './uitk-banner.css';

var getClassNameList = classNames.bind(styles);
var UitkBanner = function (props) {
    var _a;
    var children = props.children, fullWidth = props.fullWidth, theme = props.theme, domRef = props.domRef;
    var baseClass = 'uitk-banner';
    var layoutPropsToCssClassNamesMap = new Map([
        ['contentHasFullWidth', 'full-width-content'],
        ['bannerHasFullWidth', 'full-width']
    ]);
    var fullWidthClassName = function (prop) {
        return Object.entries(prop)
            .filter(function (_a) {
            _a[0]; var value = _a[1];
            return value;
        })
            .map(function (_a) {
            var key = _a[0];
            return "".concat(baseClass, "-").concat(layoutPropsToCssClassNamesMap.get(key));
        })
            .join(' ');
    };
    var fullWidthPropValueIsObject = typeof fullWidth === 'object';
    var wrapperClassNames = getClassNameList(baseClass, (_a = {},
        _a[fullWidthPropValueIsObject ? fullWidthClassName(fullWidth) : "".concat(baseClass, "-full-width")] = fullWidth,
        _a["".concat(baseClass, "-").concat(theme)] = theme,
        _a));
    var fullWidthContentWrapperClassNames = getClassNameList("".concat(baseClass, "-full-width-content-wrapper"));
    var fullWidthContentWrapper = function (fullWidthChildren) {
        var isFullWidthBanner = (fullWidthPropValueIsObject && fullWidth.bannerHasFullWidth) || fullWidth;
        var childCount = React.Children.count(fullWidthChildren);
        return isFullWidthBanner && childCount > 1 ? (React.createElement("div", { className: fullWidthContentWrapperClassNames }, fullWidthChildren)) : (React.createElement(React.Fragment, null, fullWidthChildren));
    };
    return children ? (React.createElement("div", { className: wrapperClassNames, ref: domRef },
        React.createElement(UitkContextProvider, { config: {
                context: null,
                data: {
                    contextClassNames: {
                        UitkHeading: "".concat(getClassNameList('uitk-banner-header')),
                        UitkText: "".concat(getClassNameList('uitk-banner-description')),
                        UitkIcon: "".concat(getClassNameList('uitk-banner-icon')),
                        UitkLink: "".concat(getClassNameList('uitk-banner-link'))
                    }
                }
            } }, fullWidthContentWrapper(children)))) : null;
};
UitkBanner.displayName = 'UitkBanner';
UitkBanner.defaultProps = {
    theme: 'critical'
};

export { UitkBanner };
